import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=0a273bdb&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a273bdb')) {
      api.createRecord('0a273bdb', component.options)
    } else {
      api.reload('0a273bdb', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=0a273bdb&", function () {
      api.rerender('0a273bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/Register.vue"
export default component.exports